import { cx } from './cx';

export function Rule({ className }: { className?: string }) {
  return <hr className={cx('border-t border-rule', className)} />;
}
